export const Refrigerators = [
    {
      name: "Karbonn 7 Kg Semi Automatic Top Load Washing Machine, White/Red, KJC70S-2024L",
      img: "https://www.reliancedigital.in/medias/Karbonn-KJC70S-2024L-Washing-Machine-493627329-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w2NTM1NXxpbWFnZS9qcGVnfGltYWdlcy9oYjIvaGI5Lzk5MjgzMjI3NzcxMTguanBnfDRkNTI5YTlmMzUxYmFhMTk1NDQyNDE1OWU1MDI4NTY4ZGM0OTM0Yzc4YWE5ODI2MmNhNjE0NzljYTZiMDQ2ZDA",
      price: "6,990.00",
      mrp: "13,490.00",
      discount: "48%(₹6,500)",
      id: 1,
      Rating: "⭐⭐⭐⭐(1 Review)",
      linked: "kitchen",
    },
    {
      name: "LG 8 litres RO + UV + UF Water Purifier, WW184EPB with Mineral Booster, 2-in-1 Water Solution (Drinking + Fruit & Veggie Cleaning), Black",
      img: "https://www.reliancedigital.in/medias/LG-WW184EPB-Water-Purifiers-492284046-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzOTMxNnxpbWFnZS9qcGVnfGltYWdlcy9oYTUvaDY4Lzk1OTM5OTc3ODcxNjYuanBnfDViMzQ2NGNlMzc1NDM5MzRlOWNmYzFiNTMzZWFmZDBlYzc4NDNhNmNkYTNhZWE0MWE1Y2QyYjM1NzkzNDEzYmY",
      price: "28,990.00",
      mrp: "36,999.00",
      discount: "23%(₹8,509)",
      id: 2,
      Rating: "⭐⭐⭐",
      linked: "kitchen",
    },
    {
      name: "Kelvinator 170 litres Direct Cool 2 Star Single Door kitchen, Maroon Red, KRD-C190MRP",
      img: "https://www.reliancedigital.in/medias/KELVINATOR-170L-KRD-C190MRP-kitchen-492911043-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzODA1OXxpbWFnZS9wbmd8aW1hZ2VzL2gwZS9oOTgvOTg3NzgzOTMxNDk3NC5wbmd8MTBiZjcwYmY2MjliOWY1MjMzYWY4NDlmMjU4Yzk3YWMxMDIwMDU1OTBlMGYxYWFkNTY0YmFhMWNiYTE1MWFkMA",
      price: "10,990.00",
      mrp: "11,490.00",
      discount: "31%(₹5,000)",
      id: 3,
      Rating: "⭐⭐⭐⭐",
      linked: "kitchen",
    },
    {
      name: "Samsung 1.5 Ton 4 Star AR18BY4YATA Inverter Split AC,HD Filter, 2 Way Swing, Floral Design, 5 in 1 Convertible (2022 Launch)",
     img:"https://www.reliancedigital.in/medias/SAMSUNG-AR18BY4YATA-Split-Air-conditioner-581026750-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3w1MDY2OXxpbWFnZS9qcGVnfGltYWdlcy9oNzIvaGMzLzk3ODUxMTAzOTY5NTguanBnfDVmYzhjMzYxYmVhYTVhOGRiYWViNDg4YWM2MDk0YzNiODZmYWMyMjFhNWU5MzQ5NjdiZjM5MGFlNTVjN2VlMjc",
      price: "39,990.00",
      mrp: "39,990.00",
      discount: "38%(₹24,000)",
      id: 4,
      Rating: "⭐⭐⭐⭐(1 Review)",
      linked: "kitchen",
    },
    {
      name: "Sansui 7 Kg Semi Automatic Top Loading Washing Machine with 3 Wash Programs, JSP70S-2024L, Burgundy",
      img: "https://www.reliancedigital.in/medias/SANSUI-JSP70S-2024L-Washing-Machines-492664389-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w0MjA0N3xpbWFnZS9qcGVnfGltYWdlcy9oM2IvaDUyLzk4OTQ2NjUzMjI1MjYuanBnfDRmMWJiNzhkOTRhYWM5NDMxMjk4M2VjOTMzMGE1ODk5M2JiNDc5NzE2YzYxMmEyMTRkMTI0NmI4YjdjMzJiOGU",
      price: "40,499.00",
      mrp: "65,690.00",
      discount: "38%(₹25,191)",
      id: 5,
      Rating: "⭐⭐⭐⭐(1 Review)",
      linked: "kitchen",
    },
    {
      name: "Hisense 94 Litre 2 Star Single Door kitchen, Silver RR94D4SSN",
      img: "https://www.reliancedigital.in/medias/Hisense-RR94D4SSN-kitchen-493627170-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxNDM2NnxpbWFnZS9qcGVnfGltYWdlcy9oN2MvaDZjLzk5MTY0MDc2MTE0MjIuanBnfGEzYThlMGUxZDc2ZWI2ZWE2ZjM4MmM5YTcwN2E2MTAxNTlmOTZmZGU3YWM0YjdmNzFlYzlhNTdhY2FjMjI0MGU",
      price: "38,990.00",
      mrp: "67,090.00",
      discount: "42%(₹28,100)",
      id: 6,
      Rating: "⭐⭐⭐",
      linked: "kitchen",
    },
    {
      name: "Voltas Beko 195 Litre 2 Star Direct Cool Single Door kitchen, Belus Blue, RDC215DBBRX",
      img: "https://www.reliancedigital.in/medias/Voltas-Beko-RDC215DBBRX-kitchen-492911097-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNDI2NXxpbWFnZS9qcGVnfGltYWdlcy9oMWYvaDNkLzk4Mzg4OTc3OTEwMDYuanBnfGJkMTA1ZWY4ZDU0OTM4Zjc1ZjNmMDdhY2VmYWRhOGEyN2VlZWQ2MzExYjgyODU0NjZmZjBhOTE1ZTJhYjE2NmQ",
      price: "43,749.00",
      mrp: "49,977.00",
      discount: "12%(₹6,228)",
      id: 7,
      Rating: "⭐⭐⭐⭐(1 Review)",
      linked: "kitchen",
    },
    {
      name: "Kelvinator 170 litres Direct Cool 2 Star Single Door kitchen, Maroon Red, KRD-C190MRP",
      img: "https://www.reliancedigital.in/medias/LG-P7010RRAZ-Washing-Machine-492284109-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxNzQyNnxpbWFnZS9qcGVnfGltYWdlcy9oNWIvaGNkLzk4ODkwNzI2MTEzNTguanBnfDQ2YTBhM2RjMDZmNGM3YjA1OWUyYmI5OTU0MDU1NDE5ZWViMTE3ZTViNjliMjIyMGNjNDgxYzJkYjAxMjliYTg",
      price: "39,999.00",
      mrp: "47,833.00",
      discount: "16%(₹7,834)",
      id: 8,
      Rating: "⭐⭐⭐⭐(1 Review)",
      linked: "kitchen",
    },
    {
      name: "Haier 0.9 Ton 3 Star QuriCool HSU10Q-TCW3B Triple Inverter Split AC with Copper Condenser, 50 Feet Airflow, Cools even at 60C, Hyper PCB, Self Clean Technology",
      img: "https://www.reliancedigital.in/medias/Haier-HSU10Q-TCW3B-Air-Conditioners-581026821-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNTAxOXxpbWFnZS9qcGVnfGltYWdlcy9oODEvaDUyLzk3NzM0NzU4ODkxODIuanBnfDVlOGIxYjI3ZmI3MTIyMWZiMzBjNTgzZDBmYTBjYzg4ZDE0M2UwZmUwYzlmZWEwOTg1ODBkOTk0NWE5ZDUzYmM",
      price: "57,928.00",
      mrp: "67,831.00",
      discount: "15%(₹9,903)",
      id: 10,
      linked: "kitchen",
    }
   
  ];
  
export const Laptops = [
    {
      name: "HP 14s-dr3001TU Laptop (Intel Pentium Silver N6000/8 GB/256 GB SSD/UHD Graphics/Windows 11 Home/MSO/HD), 35.6 cm (14 inch)",
      img: "https://www.reliancedigital.in/medias/HP-6K7X3PA-High-End-Laptops-492850679-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w2ODcwOXxpbWFnZS9qcGVnfGltYWdlcy9oZjcvaDc2Lzk4NTIzNzU5OTAzMDIuanBnfDhjNDMzZjgyODgyMDNkMTY0MDBlZTk3NmEzODQxODkwZDNhZGYwNTJiYTk5N2E4YzYwZWQ0OGZkYjc4ZjBjNDQ",
      price: "32,999.00",
      mrp: "37,000.00",
      discount: "11%(₹4,001)",
      Rating: "⭐⭐⭐⭐(1 Review)",
      id: 11,
      linked: "computer",
    },
    {
      name: "HP 15s-er1501AU Standard Laptop (AMD Ryzen 3 3250U/8 GB/256 GB SSD/Radeon Graphics/Windows 11 Home/MSO/HD), 39.62 cm (15.6 Inch)",
      img: "https://www.reliancedigital.in/medias/HP-6Q2M3PA-ACJ-Laptop-493177049-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzMDMwM3xpbWFnZS9qcGVnfGltYWdlcy9oZDgvaDYyLzk4NjQyODcwNTk5OTguanBnfGI5YjAxYjQ4MjliZjhjODU0NWY0NjJkODQ0MmJhZmI5Y2RmZTQ1NGZhZTg2MWFiOTRjMjQ2MzdjMzIwODg4Yjk",
      price: "28,990.00",
      mrp: "41,204.00",
      discount: "30%(₹12,214)",
      id: 12,
      linked: "computer",
    },
    {
      name: "HP Pavilion 15-eg2002TU Laptop (Intel Core i5-1240P/16GB/512GB SSD/Intel Iris Xe Graphics/Windows 11 Home/FHD/MS), 39.6 cm (15.6 inch), 66C03PA",
      img: "https://www.reliancedigital.in/medias/HP-Pavilion-15-eg2002TU-Laptop-492849709-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxMDA2NDl8aW1hZ2UvanBlZ3xpbWFnZXMvaGU2L2gwYS85ODAwOTc5NTEzMzc0LmpwZ3w3NmY1ZDJkMGY0NTFkMThjYzIzMTgxZDE2M2UzMzZmNTI1NTlmNGRjZDdmNDhmZDhhMzFhMDdjZjI2YTQ0N2Ux",
      price: "35,499.00",
      mrp: "59,390.00",
      discount: "40%(₹23,891)",
      Rating: "⭐⭐⭐⭐(1 Review)",
      id: 13,
      linked: "computer",
    },
    {
      name: "HP 15s-fq2670TU Laptop (11th Gen Intel Core i3-1115G4/8 GB RAM/256 GB SSD/Windows 11 Home/MSO/FHD), 39.6 cm (15.6 inch)",
      img: "https://www.reliancedigital.in/medias/Hp-6N043PA-ACJ-Laptop-493177597-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyOTkyOHxpbWFnZS9qcGVnfGltYWdlcy9oNjIvaDZhLzk4ODIyODk1MzcwNTQuanBnfDAzZjY0ZjBmY2RmNWY0YzBiMWU5MGQ1YTkxYWIxMmVhZGJmYTdkNDFkYWRiMGMwNzNhOTlhNzFmM2EzNWQxZGE",
      price: "41,400.00",
      mrp: "45,409.00",
      discount: "9%(₹4,009)",
      Rating: "⭐⭐⭐(2 Review)",
      id: 14,
      linked: "computer",
    },
    {
      name: "HP 15s-FQ5112TU Laptop (12th Gen Intel Core i5-1235U/16GB/512GB SSD/Iris Xe Graphics/Windows 11 Home/MSO/FHD), 39.6 cm (15.6 inch), Natural Silver",
      img: "https://www.reliancedigital.in/medias/Hp-681Y7PA-ACJ-Laptop-493178767-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNjAxOXxpbWFnZS9qcGVnfGltYWdlcy9oYTQvaDU2Lzk5MjM5NDA2MTQxNzQuanBnfGEzZDE5OGQxNmY4M2FkMGUxODU2OTg4MDdkOTFkMmZlYmJmZjdiMDAzZTVhYzBiZmVmNThiMmYwYzhmMTkyNGI",
      price: "40,499.00",
      mrp: "65,690.00",
      discount: "38%(₹25,191)",
      id: 15,
      linked: "computer",
    },
    {
      name: "Lenovo IdeaPad 3 Thin and Light Laptop (11th Gen Intel Core i3-1115G4/8 GB/512 GB SSD/Windows 11 Home/MSO/FHD), 39.62 cm (15.6 Inch)",
      img: "https://www.reliancedigital.in/medias/Lenovo-82H802L3IN-Laptop-493177740-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNTg4M3xpbWFnZS9qcGVnfGltYWdlcy9oZjcvaDk4Lzk4OTQ2NDQyNTI3MDIuanBnfDUwOTkxZTdiMWYxZjVmY2M3YWI3NDRhZDVjYjViYzMwNzZjZDE4OTk4NGM2YjM2YjkxZmE5OGU5NTgxYzI3NDg",
      price: "38,990.00",
      mrp: "67,090.00",
      discount: "42%(₹28,100)",
      Rating: "⭐⭐⭐⭐(1 Review)",
      id: 16,
      linked: "computer",
    },
    {
      name: "HP 15s-fq2672TU Laptop (11th Gen Intel Core i3-1115G4/8GB RAM/512GB SSD/UHD Graphics/Windows 11 Home/MSO/FHD), 39.6 cm (15.6 Inch), Natural Silver",
      img: "https://www.reliancedigital.in/medias/HP-6N045PA-ACJ-Laptop-492850808-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzMDMwM3xpbWFnZS9qcGVnfGltYWdlcy9oMzEvaGZjLzk4NjQyNzcyMjk1OTguanBnfGE5ZjgwMzdjYzY2MTAyMzhiZWRmNzM3OWI0NTNiMWI2MjcyNTRjMjIwNmY5ZmVlMmQwMDE3MjEyNzVmMDRmMTg",
      price: "43,749.00",
      mrp: "49,977.00",
      discount: "12%(₹6,228)",
      id: 17,
      linked: "computer",
    },
    {
      name: "HP 15s-fq2671TU Laptop (11th Gen Intel Core i3-1115G4/8 GB RAM/512 GB SSD/Windows 11 Home/MSO/FHD), 39.6 cm (15.6 inch)",
      img: "https://www.reliancedigital.in/medias/Hp-6N044PA-ACJ-Laptop-493177596-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyOTYwMHxpbWFnZS9qcGVnfGltYWdlcy9oYTIvaDMwLzk4ODIyOTA4NDc3NzQuanBnfDgzNzE4ZTExMDNkZmY1YmM2MzQyMWUwY2Y2NGRjMTA1MDJjNDVkNjQ5MTk0ZWIyMTA2NWQwY2I2MWNjOGQzZWI",
      price: "39,999.00",
      mrp: "47,833.00",
      discount: "16%(₹7,834)",
      id: 18,
      linked: "computer",
    },
    {
      name: "Asus EK522WS Laptop (11th Gen Intel Core i5-1135G7/8 GB/512 GB SSD/Iris Xe Graphics/Windows 11 Home/MSO/FHD), 35.56 cm (14 Inch)",
      img: "https://www.reliancedigital.in/medias/Asus-X415EA-EK522WS-Laptop-493178259-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNTUyNHxpbWFnZS9qcGVnfGltYWdlcy9oZWQvaDM5Lzk5MDQ3MzE1MjEwNTQuanBnfDk2NmRmZTZjNzNiMTlkMjgwMWJiM2E0NjdmOTM4NzJjM2Y5ZTAyZmJmMjZhYmIxYmJjZTVjYzNkMDlmMDE1YWQ",
      price: "49,999.00",
      mrp: "70,990.00",
      discount: "30%(₹20,991)",
      Rating: "⭐⭐⭐⭐(1 Review)",
      id: 19,
      linked: "computer",
    },
    {
      name: "HP 15s-fq5111TU Laptop (12th Gen Intel Core i5-1235U/8 GB RAM/512 GB SSD/Windows 11 Home/MSO/FHD), 39.6 cm (15.6 inch)",
      img: "https://www.reliancedigital.in/medias/Hp-6P129PA-ACJ-Laptop-493177598-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyOTYxMnxpbWFnZS9qcGVnfGltYWdlcy9oMzIvaDBjLzk4ODIyODk4NjQ3MzQuanBnfDc4ZGI4NTAzOGE1MWFhMTkyZTUxNGEzNjhlYTExMTA5YjEwNDFkNjVjNWVhNTAzZTkxNDE0YTNhZWFiZTIwZGQ",
      price: "57,928.00",
      mrp: "67,831.00",
      discount: "15%(₹9,903)",
      id: 20,
      linked: "computer",
    },
    {
      name: "HP 15s-fr5007TU Laptop (12th Gen Intel Core i5-1235U/8GB RAM/512GB SSD/Iris Xe Graphics/Windows 11 Home/MSO/FHD), 39.6 cm (15.6 Inch), Natural Silver",
      img: "https://www.reliancedigital.in/medias/HP-6P130PA-ACJ-Laptop-493177048-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzMDMwM3xpbWFnZS9qcGVnfGltYWdlcy9oMzYvaDBkLzk4NjQyNzY5MDE5MTguanBnfGMxNGRkOTVkMjdmOGJjODBhZGIzYTFkNmQ1OTJmYjE5MjdhMmQ1Y2FmMzIyNGY2ODAwMGNiYTRjZDMyMDY4MmE",
      price: "60,499.00",
      mrp: "68,000.00",
      discount: "11%(₹7,501)",
      Rating: "⭐⭐⭐⭐(1 Review)",
      id: 21,
      linked: "computer",
    },
    {
      name: "Asus EK562WS Laptop (11th Gen Intel Core i5-1135G7/8GB+32GB Intel Optane/512GB SSD/Intel Iris Xe Graphics/Windows 11/MSO/Full HD), 35.56 cm (14 inch)",
      img: "https://www.reliancedigital.in/medias/Asus-EK562WS-Laptop-492574733-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w0NDQwM3xpbWFnZS9qcGVnfGltYWdlcy9oYjYvaGE4Lzk3NTEzNTk1ODYzMzQuanBnfDI2ZGEyZjEyZTUyMWQxMGM5ODMyMjQwMzI4YTVmNjE1ZTZjNWNkMjkzYTMyODk0YmNiNzYzNWE0MmVmMzUxNDA",
      price: "48,990.00",
      mrp: "69,990.00",
      discount: "30%(₹21,000)",
      id: 22,
      linked: "computer",
    },
  ];
  
export const Card1 = [
  {
    img: "https://www.reliancedigital.in/medias/Home-Appliances-Fest-Best-Deals-on-Washing-Machines-Small-Banners.jpg?context=bWFzdGVyfGltYWdlc3w0NjkxMXxpbWFnZS9qcGVnfGltYWdlcy9oMmEvaDE4Lzk5NDg3MDc4MTU0NTQuanBnfDFiYWIzNjVhM2M1MDE5MTI2YmE3OTljMTI2ZTY5ZGM3MGRhYjRlNWZlMTZkMjcwMGE1MTljZjg4ODY2ODM3N2Y",
    caption: "Slide 1",
    linked: "televisions",
    id: 67,
  },
  {
    img: "https://www.reliancedigital.in/medias/Home-Appliances-Fes-Great-deals-on-kitchenst-Small-Banners.jpg?context=bWFzdGVyfGltYWdlc3w0Mzg4OXxpbWFnZS9qcGVnfGltYWdlcy9oZmMvaDEyLzk5NDg3MDc4ODA5OTAuanBnfGE1YTE4ZTk3OGRmNTk4N2QxOGNlYmVkZWY0MGI1OTA1NzlkMTBiM2Y1ZDEzNTU5NjliNzAyMzFhNWZiYmM1ZTY",
    caption: "Slide 2",
    linked: "headphone",
    id: 68,
  },
  {
    img: "https://www.reliancedigital.in/medias/Home-Appliances-Fest-Clearance-Sale-on-Air-Conditioners-Small-Banners.jpg?context=bWFzdGVyfGltYWdlc3w0NTA1NXxpbWFnZS9qcGVnfGltYWdlcy9oOGQvaDc5Lzk5NDg3MDc5NDY1MjYuanBnfDc0NjlhZjU0YjMwY2FjNGFlNmU2YmU5NTRhNmViOTg1M2U5NDlmODNjYjg5ODNhZjcyMTIzZGY3MzA1NTZkMDI",
    caption: "Slide 3",
    linked: "televisions",
    id: 69,
  },
  {
    img: "https://www.reliancedigital.in/medias/Home-Appliances-Fest-best-seller-home-appliances-Small-Banners.jpg?context=bWFzdGVyfGltYWdlc3w1ODEzMHxpbWFnZS9qcGVnfGltYWdlcy9oM2YvaDQ2Lzk5NDg3MDgwMTIwNjIuanBnfGZiYjg2ZjAzNGM1YzUwYjk4Mjc1MTM0YTYxOGI1YzI3NDJlNTFmNjdlNmU5Yjc3NWRkODdlMmEzNzhmMTA0NDU",
    caption: "Slide 4",
    linked: "/",
    id: 70,
  },
];
  
export const Card2 = [
  {
    img: "https://www.reliancedigital.in/medias/Motorola-Moto-G42-Small-Banner-28-12-2022.jpg?context=bWFzdGVyfGltYWdlc3wyOTgyNXxpbWFnZS9qcGVnfGltYWdlcy9oZjcvaDBiLzk5NDUxMzc0MTQxNzQuanBnfGJjMTNkOWU4ZGYxNDNhOTJiMjljMTc3YmZkNGJhODljOTYzMWRkZTI4OWJjZjkyNjFiZmJjODUzNDgyMjZjZDE",
    caption: "Slide 1",
    linked: "televisions",
    id: 71,
  },
  {
    img: "https://www.reliancedigital.in/medias/Hisense-HD-Ready-Smart-LED-TV-Small-Banner-28-12-2022.jpg?context=bWFzdGVyfGltYWdlc3w0OTgyNXxpbWFnZS9qcGVnfGltYWdlcy9oOWEvaDY1Lzk5Mzc4OTUxNjE4ODYuanBnfDZkM2I0YzZmM2UxZWNmZWE4M2FiYjEwYzM2NzdmMmM3NzQwYTE0ODFiMzA0ZDFkMzQ2ODQ4OGQ5MWRmZGI0MzM",
    caption: "Slide 2",
    linked: "headphone",
    id: 72,
  },
  {
    img: "https://www.reliancedigital.in/medias/Smartwatches-Small-Banner-28-12-2022.jpg?context=bWFzdGVyfGltYWdlc3wzMTY3M3xpbWFnZS9qcGVnfGltYWdlcy9oNTEvaGY3Lzk5Mzc4OTUyOTI5NTguanBnfDQ2NzM2YjAxZTkzYmJiMTNlMjk4ODkxNTNlMTczMDcxYzU4NjMzZDZmNWQ3N2I5MGViNmMzZDAwNjExMmUxNTE",
    caption: "Slide 3",
    linked: "televisions",
    id: 73,
  },
  {
    img: "https://www.reliancedigital.in/medias/Neckband-True-Wireless-Small-Banner-28-12-2022.jpg?context=bWFzdGVyfGltYWdlc3wzMjg5OHxpbWFnZS9qcGVnfGltYWdlcy9oNzYvaDE2Lzk5Mzc4OTUwOTYzNTAuanBnfGE1OTcxMTM4NGUyMjU3MmM4NTc4YTI1NThkMmQwOTc1ZDU2N2YwNjRjMWNiZTU2YjZiMzcwOTVkYjc0MzQ4MDc",
    caption: "Slide 4",
    linked: "/",
    id: 74,
  },
  {
    img: "https://www.reliancedigital.in/medias/Appliances-Small-Banner-28-12-2022.jpg?context=bWFzdGVyfGltYWdlc3wyODYwNHxpbWFnZS9qcGVnfGltYWdlcy9oNzkvaGU3Lzk5Mzc4OTUzNTg0OTQuanBnfGZmNzY2ZDcwZWJiMzFjMjU1Y2I2NGFhYWY2ZWFlODc1ZGUwYTAxMjEyN2NiZDI4MzRkNzlmMzNkNDU2MzQ3MGU",
    caption: "Slide 5",
    linked: "televisions",
    id: 75,
  },
  {
    img: "https://www.reliancedigital.in/medias/Printers-Monitors-Small-Banner-28-12-2022.jpg?context=bWFzdGVyfGltYWdlc3wzNDkxNHxpbWFnZS9qcGVnfGltYWdlcy9oYTkvaDFhLzk5MzkyMDYwNDU3MjYuanBnfDYwMDA0MjljYTU2YWZkOWE3MjY4YjA4ZDE1ZDVkZjkyZGVkZTdhNDU0Y2FkMWZlMzEyMjhhZWZkYTliMjZmZWM",
    caption: "Slide 6",
    linked: "headphone",
    id: 77,
  },
  {
    img: "https://www.reliancedigital.in/medias/Microwave-Small-Banner-28-12-2022.jpg?context=bWFzdGVyfGltYWdlc3wzMDcwMnxpbWFnZS9qcGVnfGltYWdlcy9oYzEvaDU1Lzk5Mzc4OTU0ODk1NjYuanBnfDUxODE0YzQyYzRkMzUwN2ZhMTk4MDgxMjUwMTQyYTg3ZjMzMzhiMmVjMGNmMzcyZTRlNmVlNWVjZjk2ZDY3MTY",
    caption: "Slide 7",
    linked: "televisions",
    id: 78,
  },
  {
    img: "https://www.reliancedigital.in/medias/Apple-MNEH3HNA-MacBook-Small-Banner-28-12-2022.jpg?context=bWFzdGVyfGltYWdlc3wzMzM3MHxpbWFnZS9qcGVnfGltYWdlcy9oZWYvaGUxLzk5Mzc4OTU1NTUxMDIuanBnfDYwYWNmOTM3MDhjYjBhYzVhZTlkMWY0MTMyZTUwMDg4NmY4NGRjOWQ3YjIyMjNlNzllMjE1MTNlZjNjZGQ2OTA",
    caption: "Slide 8",
    linked: "/",
    id: 79,
  },
];
 
export const Laptops2 = [
  {
    name: "HP 14s-dr3001TU Laptop (Intel Pentium Silver N6000/8 GB/256 GB SSD/UHD Graphics/Windows 11 Home/MSO/HD), 35.6 cm (14 inch)",
    img: "https://www.reliancedigital.in/medias/Apple-MGN63HNA-Laptops-491946461-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w0MjM5M3xpbWFnZS9qcGVnfGltYWdlcy9oYzcvaDE0Lzk0NDMwODM3ODAxMjYuanBnfGUwMGRjNjBhZDVlM2NlMmUyYmFhMTk1MjNmMDM5NTEzMWUzODRhODE0ZjdmOWM2OGEyODBjYjhjMGNlOWExZWY",
    price: "32,999.00",
    mrp: "37,000.00",
    discount: "11%(₹4,001)",
    Rating: "⭐⭐⭐⭐(1 Review)",
    id: 23,
    linked: "computer",
  },
  {
    name: "HP 15s-er1501AU Standard Laptop (AMD Ryzen 3 3250U/8 GB/256 GB SSD/Radeon Graphics/Windows 11 Home/MSO/HD), 39.62 cm (15.6 Inch)",
    img: "https://www.reliancedigital.in/medias/HP-ER1501AU-Laptop-493178397-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w1ODU4NnxpbWFnZS9qcGVnfGltYWdlcy9oNmUvaDIyLzk5MDE1NTA5Mjc5MDIuanBnfDlkOGRhZGEyOWMyZWQzNTI2YTc4ZTY5ODJhYjBlNTRlZDg5YmQ5YTczM2Q2MTg0ZGRkYTE3Y2IyMmI1NTQzMDY",
    price: "28,990.00",
    mrp: "41,204.00",
    discount: "30%(₹12,214)",
    id: 24,
    linked: "computer",
  },
  {
    name: "HP Pavilion 15-eg2002TU Laptop (Intel Core i5-1240P/16GB/512GB SSD/Intel Iris Xe Graphics/Windows 11 Home/FHD/MS), 39.6 cm (15.6 inch), 66C03PA",
    img: "https://www.reliancedigital.in/medias/HP-Pavilion-15-eg2002TU-Laptop-492849709-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxMDA2NDl8aW1hZ2UvanBlZ3xpbWFnZXMvaGU2L2gwYS85ODAwOTc5NTEzMzc0LmpwZ3w3NmY1ZDJkMGY0NTFkMThjYzIzMTgxZDE2M2UzMzZmNTI1NTlmNGRjZDdmNDhmZDhhMzFhMDdjZjI2YTQ0N2Ux",
    price: "35,499.00",
    mrp: "59,390.00",
    discount: "40%(₹23,891)",
    Rating: "⭐⭐⭐⭐(2 Review)",
    id: 25,
    linked: "computer",
  },
  {
    name: "HP 15s-fq2670TU Laptop (11th Gen Intel Core i3-1115G4/8 GB RAM/256 GB SSD/Windows 11 Home/MSO/FHD), 39.6 cm (15.6 inch)",
    img: "https://www.reliancedigital.in/medias/Hp-6N043PA-ACJ-Laptop-493177597-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyOTkyOHxpbWFnZS9qcGVnfGltYWdlcy9oNjIvaDZhLzk4ODIyODk1MzcwNTQuanBnfDAzZjY0ZjBmY2RmNWY0YzBiMWU5MGQ1YTkxYWIxMmVhZGJmYTdkNDFkYWRiMGMwNzNhOTlhNzFmM2EzNWQxZGE",
    price: "41,400.00",
    mrp: "45,409.00",
    discount: "9%(₹4,009)",
    id: 26,
    linked: "computer",
  },
  {
    name: "HP 15s-FQ5112TU Laptop (12th Gen Intel Core i5-1235U/16GB/512GB SSD/Iris Xe Graphics/Windows 11 Home/MSO/FHD), 39.6 cm (15.6 inch), Natural Silver",
    img: "https://www.reliancedigital.in/medias/Hp-681Y7PA-ACJ-Laptop-493178767-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNjAxOXxpbWFnZS9qcGVnfGltYWdlcy9oYTQvaDU2Lzk5MjM5NDA2MTQxNzQuanBnfGEzZDE5OGQxNmY4M2FkMGUxODU2OTg4MDdkOTFkMmZlYmJmZjdiMDAzZTVhYzBiZmVmNThiMmYwYzhmMTkyNGI",
    price: "40,499.00",
    mrp: "65,690.00",
    discount: "38%(₹25,191)",
    Rating: "⭐⭐⭐⭐(1 Review)",
    id: 27,
    linked: "computer",
  },
  {
    name: "Lenovo IdeaPad 3 Thin and Light Laptop (11th Gen Intel Core i3-1115G4/8 GB/512 GB SSD/Windows 11 Home/MSO/FHD), 39.62 cm (15.6 Inch)",
    img: "https://www.reliancedigital.in/medias/Lenovo-82H802L3IN-Laptop-493177740-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNTg4M3xpbWFnZS9qcGVnfGltYWdlcy9oZjcvaDk4Lzk4OTQ2NDQyNTI3MDIuanBnfDUwOTkxZTdiMWYxZjVmY2M3YWI3NDRhZDVjYjViYzMwNzZjZDE4OTk4NGM2YjM2YjkxZmE5OGU5NTgxYzI3NDg",
    price: "38,990.00",
    mrp: "67,090.00",
    discount: "42%(₹28,100)",
    id: 28,
    linked: "computer",
  },
  {
    name: "HP 15s-fq2672TU Laptop (11th Gen Intel Core i3-1115G4/8GB RAM/512GB SSD/UHD Graphics/Windows 11 Home/MSO/FHD), 39.6 cm (15.6 Inch), Natural Silver",
    img: "https://www.reliancedigital.in/medias/HP-6N045PA-ACJ-Laptop-492850808-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzMDMwM3xpbWFnZS9qcGVnfGltYWdlcy9oMzEvaGZjLzk4NjQyNzcyMjk1OTguanBnfGE5ZjgwMzdjYzY2MTAyMzhiZWRmNzM3OWI0NTNiMWI2MjcyNTRjMjIwNmY5ZmVlMmQwMDE3MjEyNzVmMDRmMTg",
    price: "43,749.00",
    mrp: "49,977.00",
    discount: "12%(₹6,228)",
    id: 29,
    linked: "computer",
  },
  {
    name: "HP 15s-fq2671TU Laptop (11th Gen Intel Core i3-1115G4/8 GB RAM/512 GB SSD/Windows 11 Home/MSO/FHD), 39.6 cm (15.6 inch)",
    img: "https://www.reliancedigital.in/medias/Hp-6N044PA-ACJ-Laptop-493177596-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyOTYwMHxpbWFnZS9qcGVnfGltYWdlcy9oYTIvaDMwLzk4ODIyOTA4NDc3NzQuanBnfDgzNzE4ZTExMDNkZmY1YmM2MzQyMWUwY2Y2NGRjMTA1MDJjNDVkNjQ5MTk0ZWIyMTA2NWQwY2I2MWNjOGQzZWI",
    price: "39,999.00",
    mrp: "47,833.00",
    discount: "16%(₹7,834)",
    id: 30,
    linked: "computer",
  },
  {
    name: "Asus EK522WS Laptop (11th Gen Intel Core i5-1135G7/8 GB/512 GB SSD/Iris Xe Graphics/Windows 11 Home/MSO/FHD), 35.56 cm (14 Inch)",
    img: "https://www.reliancedigital.in/medias/Asus-X415EA-EK522WS-Laptop-493178259-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNTUyNHxpbWFnZS9qcGVnfGltYWdlcy9oZWQvaDM5Lzk5MDQ3MzE1MjEwNTQuanBnfDk2NmRmZTZjNzNiMTlkMjgwMWJiM2E0NjdmOTM4NzJjM2Y5ZTAyZmJmMjZhYmIxYmJjZTVjYzNkMDlmMDE1YWQ",
    price: "49,999.00",
    mrp: "70,990.00",
    discount: "30%(₹20,991)",
    Rating: "⭐⭐⭐⭐(1 Review)",
    id: 31,
    linked: "computer",
  },
  {
    name: "HP 15s-fq5111TU Laptop (12th Gen Intel Core i5-1235U/8 GB RAM/512 GB SSD/Windows 11 Home/MSO/FHD), 39.6 cm (15.6 inch)",
    img: "https://www.reliancedigital.in/medias/Hp-6P129PA-ACJ-Laptop-493177598-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyOTYxMnxpbWFnZS9qcGVnfGltYWdlcy9oMzIvaDBjLzk4ODIyODk4NjQ3MzQuanBnfDc4ZGI4NTAzOGE1MWFhMTkyZTUxNGEzNjhlYTExMTA5YjEwNDFkNjVjNWVhNTAzZTkxNDE0YTNhZWFiZTIwZGQ",
    price: "57,928.00",
    mrp: "67,831.00",
    discount: "15%(₹9,903)",
    id: 32,
    linked: "computer",
  },
  {
    name: "HP 15s-fr5007TU Laptop (12th Gen Intel Core i5-1235U/8GB RAM/512GB SSD/Iris Xe Graphics/Windows 11 Home/MSO/FHD), 39.6 cm (15.6 Inch), Natural Silver",
    img: "https://www.reliancedigital.in/medias/HP-6P130PA-ACJ-Laptop-493177048-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzMDMwM3xpbWFnZS9qcGVnfGltYWdlcy9oMzYvaDBkLzk4NjQyNzY5MDE5MTguanBnfGMxNGRkOTVkMjdmOGJjODBhZGIzYTFkNmQ1OTJmYjE5MjdhMmQ1Y2FmMzIyNGY2ODAwMGNiYTRjZDMyMDY4MmE",
    price: "60,499.00",
    mrp: "68,000.00",
    discount: "11%(₹7,501)",
    Rating: "⭐⭐⭐(1 Review)",
    id: 33,
    linked: "computer",
  },
  {
    name: "Asus EK562WS Laptop (11th Gen Intel Core i5-1135G7/8GB+32GB Intel Optane/512GB SSD/Intel Iris Xe Graphics/Windows 11/MSO/Full HD), 35.56 cm (14 inch)",
    img: "https://www.reliancedigital.in/medias/Asus-EK562WS-Laptop-492574733-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w0NDQwM3xpbWFnZS9qcGVnfGltYWdlcy9oYjYvaGE4Lzk3NTEzNTk1ODYzMzQuanBnfDI2ZGEyZjEyZTUyMWQxMGM5ODMyMjQwMzI4YTVmNjE1ZTZjNWNkMjkzYTMyODk0YmNiNzYzNWE0MmVmMzUxNDA",
    price: "48,990.00",
    mrp: "69,990.00",
    discount: "30%(₹21,000)",
    Rating: "⭐⭐⭐⭐(1 Review)",
    id: 34,
    linked: "computer",
  },
];

export const Phones = [
  {
    name: "Apple iPhone 14 Plus 512 GB, Midnight",
    img: "https://www.reliancedigital.in/medias/Apple-iPhone-14-Mobile-Phone-493177749-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyMzA3N3xpbWFnZS9qcGVnfGltYWdlcy9oYmIvaDFlLzk4OTA0ODg0ODM4NzAuanBnfDkyMjVmOGIzMjIxNjc1MWQwYjM3MDI0M2I1OTEzYTcyMzYwNmZhMTdiYTgwYjVjYjQyNjQ3ODgzZjQ1NzQyZTM",
    caption: "Slide 1",
    price: "1,09,900.00",
    mrp: "1,10,999.00",
    discount: "1%(₹1,099)",
    id: 35,
    Rating: "⭐⭐⭐⭐(1 Review)",
    linked: "mobile",
  },
  {
    name: "Apple iPhone 14 Plus 128 GB, Starlight",
    img: "https://www.reliancedigital.in/medias/Apple-iPhone-14-Plus-Mobile-Phone-493177765-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNDAyMHxpbWFnZS9qcGVnfGltYWdlcy9oNDIvaDAyLzk4OTA1MzYwNjMwMDYuanBnfDQzYjhhMjgyYWJlYWJkNTBiNDM4NzI5YjA4NTU4NzY3Y2Y2ZTJjYWQxNDQ4NDE0ZWViYzJmZTdjZjYwNTQ5ZGU",
    caption: "Slide 2",
    price: "89,990.00",
    mrp: "90,889.00",
    id: 36,
    discount: "1%(₹8,99)",
    linked: "mobile",
  },
  {
    name: "Apple iPhone 14 Plus 128 GB, Blue",
    img: "https://www.reliancedigital.in/medias/Apple-iPhone-14-Mobile-Phone-493177756-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNjYwNXxpbWFnZS9qcGVnfGltYWdlcy9oYTcvaDgwLzk4OTA1MDE1OTEwNzAuanBnfGExOTdiMzQwNWFjYzY5NWFhNGY3MjVkYmFkZWY1YjdmNjFiNjU0Yzg4NWMzNDRiYmI2NmYzYTM2N2E0ZTY1MzU",
    caption: "Slide 3",
    price: "89,990.00",
    mrp: "90,889.00",
    id: 37,
    discount: "1%(₹8,99)",
    Rating: "⭐⭐⭐(1 Review)",
    linked: "mobile",
  },
  {
    name: "Apple iPhone 14 Plus 128 GB, Blue",
    img: "https://www.reliancedigital.in/medias/Apple-iPhone-14-Plus-Mobile-Phone-493177767-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNDEwNHxpbWFnZS9qcGVnfGltYWdlcy9oOWIvaGFmLzk4OTA1NDE5NjEyNDYuanBnfGEwNTZiM2Y3MWY1YmFmOTU3MDI2MjUxM2E0NTI0NTIwMzFhMTE5Y2NjNzQ2MWY1MWI5ZjVmN2JjMmRjZjY3YTU",
    caption: "Slide 4",
    price: "89,990.00",
    id: 38,
    mrp: "90,889.00",
    discount: "1%(₹8,99)",
    linked: "mobile",
  },
  {
    name: "Apple iPhone 14 Plus 512 GB, Midnight",
    img: "https://www.reliancedigital.in/medias/Apple-iPhone-14-Mobile-Phone-493177749-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyMzA3N3xpbWFnZS9qcGVnfGltYWdlcy9oYmIvaDFlLzk4OTA0ODg0ODM4NzAuanBnfDkyMjVmOGIzMjIxNjc1MWQwYjM3MDI0M2I1OTEzYTcyMzYwNmZhMTdiYTgwYjVjYjQyNjQ3ODgzZjQ1NzQyZTM",
    caption: "Slide 1",
    price: "1,09,900.00",
    mrp: "1,10,999.00",
    id: 39,
    discount: "1%(₹1,099)",
    Rating: "⭐⭐⭐⭐(1 Review)",
    linked: "mobile",
  },
];

export const TV = [
  {
    name: "MI 32 HD Ready Smart LED TV, 4A Horizon, ELA4546IN",
    img: "https://www.reliancedigital.in/medias/Mi-4A-Horizon-Edition-Television-492166368-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxNjcxM3xpbWFnZS9qcGVnfGltYWdlcy9oNDcvaDk4Lzk3OTA4NzQ3MTQxNDIuanBnfDhjNDk4M2M1MTM1YTViZmFkMTY1NGM1ZmU4ZjFiODNiOGQ2NTMyYzUxYjg0NWJmYWE4MjIzODg4YmEzMWM5ZDY",
    price: "16,499.00",
    mrp: "19,999.00",
    discount: "18%(₹3,500)",
    Rating: "⭐⭐⭐⭐(1 Review)",
    id: 40,
    linked: "televisions",
  },
  {
    name: "IFFALCON 139.7 cm (55 Inch) Ultra HD (4K) Smart LED TV, 55U71",
    img: "https://www.reliancedigital.in/medias/Iffalcon-55U71-Television-493179244-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w0MjUyMXxpbWFnZS9qcGVnfGltYWdlcy9oZDMvaGM0Lzk4OTU3NzUwMTA4NDYuanBnfDhlMGU4MDEzNjUzZGNmYzM4ZTkzNTA2OGUwNDkyY2Y2ZTZkMzI5NzIyZjQzMzgzYzI1OTU0MTY5MGZjYTk5M2Y",
    price: "25,990.00",
    mrp: "70,990.00",
    discount: "63%(₹45,000)",
    id: 42,
    linked: "televisions",
  },
  {
    name: "Samsung Wondertainment 80 cm (32 Inch) Smart HD Ready TV, UA32T4340BKXXL",
    img: "https://www.reliancedigital.in/medias/Samsung-UA32T4340BKXXL-Smart-Television-492403650-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNDk1NnxpbWFnZS9qcGVnfGltYWdlcy9oNDcvaDE3Lzk4NDIyMDUxMzA3ODIuanBnfDljNDA4NjY5ZmYwYjNmMTBlMmYwZGEwODNkMTk5M2ZkMDc5MTgzZTAyY2VmNWYwMjJmYWNlZmEwNzBkNmYyZjI",
    price: "13,490.00",
    mrp: "22,900.00",
    discount: "41%(₹9,410)",
    id: 43,
    linked: "televisions",
  },
  {
    name: "Kodak 139 cm (55 inch) Ultra HD (4K) LED Smart TV, 7XPRO Series 55UHDX7XPRO, Quad Core Processor, Built-In Chromecast",
    img: "https://www.reliancedigital.in/medias/Kodak-55UHDX7XPRO-Television-492166145-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w3NDEyN3xpbWFnZS9qcGVnfGltYWdlcy9oYzIvaDNmLzk1MTE0Nzk2MDczMjYuanBnfGNkZjZkNTdlYWU4YmQ3YWM0MjU2MWY4OGNlNTBkZTM0YWIzOTQ1NTAwODFkYjkzODJjNGIxNzgwOWI4NzIyZmU",
    price: "24,999.00",
    mrp: "46,999.00",
    discount: "47%(₹22,000)",
    Rating: "⭐⭐⭐⭐(1 Review)",
    id: 44,
    linked: "televisions",
  },
  {
    name: "Sansui 80 cm (32 Inch) HD Ready Smart TV, Neo Series JSW32CSHD",
    img: "https://www.reliancedigital.in/medias/Sansui-JSW32CSHD-Television-493179126-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzNzMxMnxpbWFnZS9qcGVnfGltYWdlcy9oYmMvaGRhLzk4OTI2OTQ1NTY3MDIuanBnfDNiNGIzMzY5MzI1NjE2YzA0MTlhMjNmY2JkNGE1MjBhMDFjZWI0ODBlMGRmZjU3NjIwMzI0YTJlNzlmMWI4MTQ",
    price: "8,999.00",
    mrp: "19,990.00",
    discount: "55%(₹10,991)",
    id: 45,
    linked: "televisions",
  },
  {
    name: "Kodak 80 cm (32 inch) HD Ready LED Smart TV, 7XPRO Series 32HDX7XPRO, Quad Core Processor, Built-in Chromecast",
    img: "https://www.reliancedigital.in/medias/Kodak-32HDX7XPRO-Televisions-492166141-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNjIzNHxpbWFnZS9qcGVnfGltYWdlcy9oZmQvaDgwLzk4OTQ2ODczNDI2MjIuanBnfDAxNzdkZTU5YWY0ZjdkMWFhN2NhM2E3ZDY4MjkwZjIzMGNkYjIzYzNkMDkyMTZlNWU3N2ViZTA2YTE4YzcxMzc",
    price: "9,999.00",
    mrp: "18,499.00",
    discount: "46%(₹8,500)",
    id: 46,
    linked: "televisions",
  },
  {
    name: "Hisense 108 cm (43 inch) 2Yr Warranty 4K Ultra HD Smart Certified Android LED TV 43A6GE (Black) with Dolby Vision and ATMOS",
    img: "https://www.reliancedigital.in/medias/HISENSE-43A6GE-Smart-LED-492338735-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w3NjY5OXxpbWFnZS9qcGVnfGltYWdlcy9oMTEvaDcwLzk3Nzg4NDI1OTk0NTQuanBnfGFiNzdlZmMxODczMmUyNzdlMDRkZGJjMzEyNTA4YTNhMGVhYjlhYmU0MzYwNDBmNmY4NjBlOGJjNDQwZjEzMjg",
    price: "19,990.00",
    mrp: "44,990.00",
    discount: "56%(₹25,000)",
    Rating: "⭐⭐⭐(1 Review)",
    id: 47,
    linked: "televisions",
  },
  {
    name: "Hisense Vivid 80 cm(32 inch) HD Ready Smart LED TV, E4G, 32E4G",
    img: "https://www.reliancedigital.in/medias/Hisense-32E4G-Television-492912681-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w0MDM0NXxpbWFnZS9qcGVnfGltYWdlcy9oMTIvaGVlLzk4Mjk4NTgzNDQ5OTAuanBnfDIzYjlkNDkwNjgwYWViZWY0ZjgxZGI5Njk2MGJiYWNmNGU0MmExOGZlNjFhM2E3YTIyNGYxM2FmMzJmZWI5NmU",
    price: "10,990.00",
    mrp: "24,990.00",
    discount: "56%(₹14,000)",
    id: 48,
    linked: "televisions",
  },
];

export const AppleWatch = [
  {
    name: "Apple Watch Ultra GPS + Cellular - 49 mm Titanium Case with Blue and Gray Trail Loop - M/L",
    img: "https://www.reliancedigital.in/medias/Apple-Ultra-Sports-Fitness-Watches-493177945-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w2NTIwNXxpbWFnZS9qcGVnfGltYWdlcy9oZGIvaDA1Lzk4OTE5NjUwNDI3MTguanBnfGQ5YzE2NGM4OGU1MWM3ZDM3NDc2ODQyNDQzNzljMWU1NmM1NmFhZTQ0YzY3MDUxODlhYmVhMTA1MGQ0YjgzZjA",
    caption: "Slide 1",
    mrp: "85,405.00",
    price: "89,900.00",
    id: 49,
    discount: "5%(₹4,495)",
    Rating: "⭐⭐⭐⭐(2 Review)",
    linked: "personal",
  },
  {
    name: "Apple Watch SE GPS + Cellular - 40 mm Silver Aluminium Case with White 2nd Generation Sport Band",
    img: "https://www.reliancedigital.in/medias/Apple-SE-Sports-Fitness-Watches-493177926-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzNDk1OXxpbWFnZS9qcGVnfGltYWdlcy9oMmEvaDJkLzk4OTE5OTE5NzgwMTQuanBnfDdjNDY1NzJlNjlkNjg0MmZiZDQ2MTBjNzM0ZmY1NTZhYjExYTZlYTk2MmVlNDRmYzU4Yjc5MTNhZDkyOTZkNjc",
    caption: "Slide 2",
    mrp: "33,155.00",
    id: 50,
    price: "34,900.00",
    discount: "5%(₹1,745)",
    linked: "personal",
  },
  {
    name: "Apple Watch Ultra GPS + Cellular - 49 mm Titanium Case with Orange Alpine Loop - Medium",
    img: "https://www.reliancedigital.in/medias/Apple-Ultra-Sports-Fitness-Watches-493177937-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w2NjAyN3xpbWFnZS9qcGVnfGltYWdlcy9oZjcvaGE0Lzk4OTE5NDUwNTQyMzguanBnfDUzMWY2ZWFjYTBiMzAzZDA3MjFlOGRiOTlhZjQyYjMzNzFjNmZjYTQyMzNmYWYwNzUzYjdjODlkZmU2Y2UxZDU",
    caption: "Slide 3",
    mrp: "36,005.00",
    price: "37,900.00",
    id: 51,
    discount: "5%(₹1,895)",
    Rating: "⭐⭐⭐⭐(1 Review)",
    linked: "personal",
  },
  {
    name: "Apple Watch SE GPS + Cellular - 44 mm Silver Aluminium Case with White 2nd Generation Sport Band",
    img: "https://www.reliancedigital.in/medias/Apple-SE-Sports-Fitness-Watches-493177923-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzNTU2NnxpbWFnZS9qcGVnfGltYWdlcy9oMzgvaDI5Lzk4OTE5ODM3ODYwMTQuanBnfGQ4YzkwMmIwZjlmNjdmOGQzNmIxOGEyZGNjNTk5ZThlYjY2NTFmNTQzYWY5ZTJkNDE3MTk4YmUwZTcxY2ZiMzg",
    caption: "Slide 4",
    mrp: "85,405.00",
    price: "89,900.00",
    id: 52,
    discount: "5%(₹4,495)",
    linked: "personal",
  },
  {
    name: "Apple Watch Ultra GPS + Cellular - 49 mm Titanium Case with Blue and Gray Trail Loop - M/L",
    img: "https://www.reliancedigital.in/medias/Apple-Ultra-Sports-Fitness-Watches-493177945-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w2NTIwNXxpbWFnZS9qcGVnfGltYWdlcy9oZGIvaDA1Lzk4OTE5NjUwNDI3MTguanBnfGQ5YzE2NGM4OGU1MWM3ZDM3NDc2ODQyNDQzNzljMWU1NmM1NmFhZTQ0YzY3MDUxODlhYmVhMTA1MGQ0YjgzZjA",
    caption: "Slide 1",
    mrp: "85,405.00",
    price: "89,900.00",
    id: 53,
    discount: "5%(₹4,495)",
    Rating: "⭐⭐⭐⭐(1 Review)",
    linked: "personal",
  },
];

export const Headphones = [
  {
    name: "boAt Rockerz 255R Pro in Ear Bluetooth Neckband with Upto 10 Hours Playback, ASAP Charge, IPX5, boAt Signature Sound & Integrated Controls(Active Black)",
    img: "https://www.reliancedigital.in/medias/boAt-Rockerz-255-Pro-Active-Bluetooth-Earphones-492912673-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzMzcwNHxpbWFnZS9qcGVnfGltYWdlcy9oYTAvaGE3Lzk4MzIxMDEwODUyMTQuanBnfDJkNjAyYzhmNjBmMTIzYTRmZGNjMmJhZWEyY2ZiYzNkYmY3MjM1NjUwODIyOTNjNzg1YzE5MzFkNjc0ZWI2NDg",
    price: "1,099.00",
    mrp: "3,499.00",
    discount: "69%(₹2,400)",
    Rating: "⭐⭐⭐⭐(1 Review)",
    id: 54,
    linked: "headphone",
  },
  {
    name: "boAt Airdopes 131 RTL Twin Wireless Earbuds with IWP Technology, Bluetooth V5.0, Immersive Audio, Up to 15H Total Playback, Instant Voice Assistant and Type-C Charging",
    img: "https://www.reliancedigital.in/medias/boAt-Airdopes-131-RTL-Earbuds-491973401-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w1ODM2fGltYWdlL2pwZWd8aW1hZ2VzL2g2OC9oYzgvOTgzMjI2MTg3Nzc5MC5qcGd8ZmIzMWZlZDQxNGRiYmQ1YWVjYTNmNDM3MTc4MGNlYmNlYjg1NTZmNDA0NzAzOTY5NmQyNjYyNmJhOWIwZGMxYg",
    price: "1,099.00",
    mrp: "2,990.00",
    discount: "63%(₹1,891)",
    id: 55,
    linked: "headphone",
  },
  {
    name: "Apple MME73HN/A 3rd Generation Airpods with Mic and Wireless Charging Case, White",
    img: "https://www.reliancedigital.in/medias/Apple-Airpods-492571632-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxMTQ1NnxpbWFnZS9qcGVnfGltYWdlcy9oMjgvaGU2Lzk4MjU2MDg5OTA3NTAuanBnfGU0MjZmMjM3YjYwMDhkYmUxOWIwYjllNTczODI0YzdjY2EyYTMyYjY5MTQ3ZTE4Y2I2YzEwNGMyN2Q1N2MwMzU",
    price: "18,500.00",
    id: 56,
    linked: "headphone",
    Rating: "⭐⭐⭐⭐(1 Review)",
  },
  {
    name: "boAt Airdopes 148 True Wireless Airdopes, Active Black",
    img: "https://www.reliancedigital.in/medias/boAt-Airdopes148-TrueWireless-492579512-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxODQxNHxpbWFnZS9qcGVnfGltYWdlcy9oODMvaDIwLzk4MTY0MDE1MTA0MzAuanBnfDA2YzYxZGIxZmViZGE4MmY4ZTI0MTI0MmNhMDY1YzYzYTI1NjQzZjY4YWMyY2ZkNjNhYWYzZTUwNTE0NmE1Yzk",
    price: "1,299.00",
    mrp: "4,490.00",
    discount: "71%(₹3,191)",
    id: 4,
    linked: "headphone",
  },
  {
    name: "OnePlus Nord Buds Wireless Earbuds with 4 Mics and AI Noise Reduction, Black Slate",
    img: "https://www.reliancedigital.in/medias/OnePlus-NORD-BUDS-True-Wireless-492912670-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxODg4OHxpbWFnZS9qcGVnfGltYWdlcy9oOWMvaGIyLzk4MzQ2NzI4MTYxNTguanBnfGM1NTZmODdmODNkMTQ2ZDUyNjU4MGQzMzY1YzM2OTBiNzYyZjdhYzQxY2UxZWQwOGMzMzBkNTdlZmNlOGNjODg",
    price: "2,499.00",
    mrp: "2,999.00",
    discount: "17%(₹500)",
    Rating: "⭐⭐⭐⭐(1 Review)",
    id: 57,
    linked: "headphone",
  },
  {
    name: "boAt Airdopes 131 RTL Twin Wireless Earbuds with IWP Technology, Bluetooth V5.0, Immersive Audio, Up to 15H Total Playback, Instant Voice Assistant and Type-C Charging, Black",
    img: "https://www.reliancedigital.in/medias/boAt-Airdopes-131-Airdopes-492912674-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w0ODcwfGltYWdlL2pwZWd8aW1hZ2VzL2hmYi9oZmMvOTkwNDQ3MzE3ODE0Mi5qcGd8YWQ4ZTg0NDAwMjg3M2Q2NDQwMzRlNTVjNzA3NDU5MDkyZTE5NzY1MzZmNGY2ODY5OWZiYzVkOWEzOTQ2OWU3YQ",
    price: "1,099.00",
    mrp: "2,990.00",
    discount: "63%(₹1,891)",
    id: 58,
    linked: "headphone",
  },
  {
    name: "OnePlus Bullets Z2 Wireless Neckband Earphone with AI Noise Cancellation, Magico Black",
    img: "https://www.reliancedigital.in/medias/OnePlus-Bullets-Z2-Wireless-Earphone-492796790-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w4MTk1fGltYWdlL2pwZWd8aW1hZ2VzL2hjNi9oMDkvOTgzODE4MDA0MDczNC5qcGd8NWRkMjEyZjQxMTBkYzliZmY1ZTA0NTIwMmQ3MWMxZjgyMDE3ZjdiMjVmMmFjNGY1OTg4NWNjNDU0NTY0MzdlOA",
    price: "1,699.00",
    mrp: "2,290.00",
    discount: "26%(₹591)",
    id: 59,
    linked: "headphone",
  },
  {
    name: "pTron InTunes Classic Bluetooth 5.2 Wireless Neckband Earphones with 24Hrs Playback Time, Made in India, Hi-Fi Stereo Audio, Deep Bass, Type-C Fast Charging, Voice Assistant, IPX4 & In-line Music & Call Controls (Black)",
    img: "https://www.reliancedigital.in/medias/pTron-InTunes-Classic-Bluetoth-Earphones-493285627-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzMTQ1OHxpbWFnZS9qcGVnfGltYWdlcy9oNzQvaGYxLzk4Njc1ODE2NTMwMjIuanBnfGNlMjliN2RhOGFiMmE1ZThjZDhhZjhhOTZlZWYxYTgzMjcyNzQyZGViZTE2YzdkMDkxZGI3YTQyMjQwYTIzM2I",
    price: "499.00",
    mrp: "1,899.00",
    discount: "74%(₹1,400)",
    Rating: "⭐⭐⭐⭐(1 Review)",
    id: 60,
    linked: "headphone",
  },
  {
    name: "pTron Basspods P181 Bluetooth 5.1 Wireless headphone, 32Hrs Total Playtime, Immersive Stereo Sound, Stereo Calls, Snug-fit TWS Earbuds, Touch Controls, Voice Assistance, Type-C Fast Charging & IPX4 (Black)",
    img: "https://www.reliancedigital.in/medias/pTron-Basspods-P181-Bluetooth-Earphones-492796965-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w0MjMyM3xpbWFnZS9qcGVnfGltYWdlcy9oYWIvaDlmLzk4MjU4OTQ4MjYwMTQuanBnfDFiNDA1MjIwOGNkMjM4YmVmYThiMjY2OWEyMzg3OWRmNDQ3MDBhYzMwYjcxOTMyZWEwNmRhMDQyMWMyMDZmZTk",
    price: "649.00",
    mrp: "2,999.00",
    discount: "78%(₹2,350)",
    id: 61,
    linked: "headphone",
  },
  {
    name: "Apple MLWK3HN/A Airpods Pro with Magsafe Charging Case, White",
    img: "https://www.reliancedigital.in/medias/Apple-Airpods-pro-492571631-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxMTAyNnxpbWFnZS9qcGVnfGltYWdlcy9oZjgvaDg3Lzk4MjU2MDg2NjMwNzAuanBnfGRlN2MxYjQxYWMyMmU1MzFlY2E0NzkxNGQ4ZjNmNTJhZGExZjIxODQ4MTZkMjA5ZmE2YWU1N2FmNmJhOWJkYjM",
    price: "20,990.00",
    mrp: "26,300.00",
    discount: "20%(₹5,310)",
    id: 61,
    linked: "headphone",
  },
];

export const Explore1 = [
  {
    img: "https://www.reliancedigital.in/medias/iphone-pro-11-01.png?context=bWFzdGVyfGltYWdlc3wyOTc3NnxpbWFnZS9wbmd8aW1hZ2VzL2gxNi9oNWUvOTI3NjA1OTkxMDE3NC5wbmd8MzdkYzljODgzMDcyM2ZjMjJmZDI2ZjMwNjhkZmU5YjFmOTJmMGRmOTFiYzc4ZjcyMDRhMjQ5MWMyNjYwOTgxYg",
    caption: "Slide 1",
    categories: "Smartphone",
    linked: "personal",
    id: 62,
  },
  {
    img: "https://www.reliancedigital.in/medias/Washing-Machine-180x180-15-01-2019.png?context=bWFzdGVyfGltYWdlc3wzNDU4MXxpbWFnZS9wbmd8aW1hZ2VzL2gzOC9oM2UvOTI1MTA1MDg4MTA1NC5wbmd8ZDAyZGNkMzU1MzE3N2E2OGFlOTliMzUyODZkYzlkNTc0NzFmODllY2JiZDVlNzdhYjg3MTgyMTc4ZGVhODA3ZA",
    caption: "Slide 2",
    categories: "Washing Machines",
    linked: "/",
    id: 62,
  },
  {
    img: "https://www.reliancedigital.in/medias/Laptop-180x180-15-01-2019.png?context=bWFzdGVyfGltYWdlc3wyOTAwOXxpbWFnZS9wbmd8aW1hZ2VzL2g0Mi9oNTYvOTI1MTA1MDYxODkxMC5wbmd8N2ZjYTg0ZDAyOTZmMmQ5OTZhZDNiM2M4NDg0ZDgxY2UyNzNjMmJiYzMwZTZiOGQwOWE5N2JlZDI4M2ViMGZjNw",
    caption: "Slide 3",
    categories: "Laptops",
    linked: "computer",
    id: 63,
  },
  {
    img: "https://www.reliancedigital.in/medias/TV-180x180-15-01-2019.png?context=bWFzdGVyfGltYWdlc3w0OTM4M3xpbWFnZS9wbmd8aW1hZ2VzL2g1ZC9oMTEvOTI1MTA1MDU1MzM3NC5wbmd8MThiNmU4NTZiNWI5MTE1ZGVjYjA4ZjIwM2QwZjUyMzFlOGExZTY0YmQ0MTRkYTkyN2M2MDZiYzUzZDY1ZjM4Ng",
    caption: "Slide 4",
    categories: "Televisions",
    linked: "televisions",
    id: 64,
  },
  {
    img: "https://www.reliancedigital.in/medias/Watch-180x180-27-02-2020.png?context=bWFzdGVyfGltYWdlc3w2Njk2fGltYWdlL3BuZ3xpbWFnZXMvaGQ1L2g2My85MjUzNTA3NTk2MzE4LnBuZ3w4NmEwODU5NDI5YzVlMzJjNzRlNzNlYmJkMmJmYTZjMTI2OWY0YTUxYWU3YzMzM2E3YTc5YjljZmU4ZGMyNGQ2",
    caption: "Slide 5",
    categories: "Smart Wearables",
    linked: "personal",
    id: 65,
  },
  {
    img: "https://www.reliancedigital.in/medias/Speaker-Headset-180x180-15-01-2019.png?context=bWFzdGVyfGltYWdlc3wyNzUzN3xpbWFnZS9wbmd8aW1hZ2VzL2g1YS9oODAvOTI1MTA1MDY4NDQ0Ni5wbmd8YmMyYWJiNzRhMzk4NjMxMDRmOWRlZGI1MzVjZDk2Y2IxYTkxOGNlNjlmZjA2YTgwMGIwMjhmYTJlYmNhYjIwOA",
    caption: "Slide 5",
    categories: "Speakers & Headsets",
    linked: "/",
    id: 66,
  },
];

export const BrandPromises = [
  {
    img: "https://www.reliancedigital.in/medias/Insta-Delivery-Brand-Promise-Icon.png?context=bWFzdGVyfGltYWdlc3wxNTM3fGltYWdlL3BuZ3xpbWFnZXMvaGI2L2gwNS85NDQ3MTcwMzQyOTQyLnBuZ3w2Yzc1ZmY1ZjYwOWIyNWU0ZTgwMjFlYmRkMTU5ZTgzMGI4ZDNmZTE2NjVjYmRlMmUwMmRiODI2OTExNWM5ZTdk",
    caption: "Slide 1",
    title: "INSTA DELIVERY",
    desc: "LESS THAN 3 HRS.",
  },
  {
    img: "https://www.reliancedigital.in/medias/Best-Finance-Options-2.png?context=bWFzdGVyfGltYWdlc3wxMjM4fGltYWdlL3BuZ3xpbWFnZXMvaDJmL2gxOS85NDQ3MTcwNDA4NDc4LnBuZ3xlMDBiNjY4YWI5YzMzYjZkZDhlZTMyMDhjYjE2YzI2OTY2NWJhYjk2M2VkNzdjZDg3NTNlMGEyMTA1ZjFlODZh",
    caption: "Slide 2",
    title: "BEST FINANCE OPTIONS",
    desc: "WIDE RANGE",
  },
  {
    img: "https://www.reliancedigital.in/medias/service-img.png?context=bWFzdGVyfGltYWdlc3w5MTB8aW1hZ2UvcG5nfGltYWdlcy9oMDYvaGEzLzkwOTA3OTc5OTQwMTQucG5nfGJjZmJhNzM1ODdkYTQ5ODI3YzNiMzQ1ZTdlM2JjNjUwMTBjM2E3YWFjNmUxZjdmMmEyOGRjZDMxOGI4ZWE0MWY",
    caption: "Slide 3",
    title: "SERVICE GUARANTEE",
    desc: "HASSLE FREE",
  },
  {
    img: "https://www.reliancedigital.in/medias/unmatched-network-img.png?context=bWFzdGVyfGltYWdlc3w3NDV8aW1hZ2UvcG5nfGltYWdlcy9oODIvaDJhLzkwOTA3OTgwNTk1NTAucG5nfDFmMThjYzdiYTNiOTgxYjA5YzdlZTFiMmQyODI5MGY2NTM4ZTcxOWZkZTA1ZjAzY2Q1ZTk5YjQ1NTMxMWViYzU",
    caption: "Slide 4",
    title: "UNMATCHED NETWORK",
    desc: "700 CITIES, 2000 STORES",
  },
];